import { makeStyles } from "@hawkins/styles";
import { Dimensions } from "@hawkins/variables";

type StylesProps = {
  showBack: boolean;
  columns?: number;
};

export const usePageStyles = makeStyles({
  main: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    width: '80vw',
    maxWidth: 900,
    margin: '0 5vw',
    height: '100%',
    paddingTop: Dimensions.Space24,
    paddingBottom: Dimensions.Space24,
  },
  titleBox: {
    marginTop: Dimensions.Space144,
    columnGap: Dimensions.Space16,
    display: "flex",
    flexDirection: "row",
  },
  contentBox: {
    marginTop: Dimensions.Space24,
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: ({ columns }: StylesProps) => `repeat(${columns}, 1fr)`,
    placeItems: 'flex-start',
  },
  nestedHeading: ({ showBack }: StylesProps) => ({
    textDecoration: showBack ? 'underline' : 'none',
  }),
});
